import {appdata} from "./logic_tmp/appdata/AppData";
export function sendHeight(action) {
    if (appdata.iframeId === undefined) return
    let h = document.body.scrollHeight
    //console.log("Sending heigth ...." + h + " from " + appdata.iframeId + " on:" + action)
    window.parent.postMessage({
        "action": "resize", "id": appdata.iframeId, "payload": (h) + "px"
    }, '*')
}
